// Importing external libraries
import html2canvas from 'html2canvas';
import pdfMake from 'pdfmake';

export const COLORS = {
  BLACK: '#2d2d2f',
  BLUE: '#004a9d',
  GRAY_1: '#606060',
  GRAY_2: '#c9c9c9',
  GRAY_3: '#ececec',
  GRAY_4: '#f5f5f5',
  GREEN: '#c8e6c9',
  LIGHT_BLUE: '#9fcdf0',
  PURPLE: '#7b1fa2',
  RED: '#f5222d',
  WHITE: '#ffffff',
};

export const DEFAULT_STYLES = {
  h1: {
    fontSize: 28,
    color: COLORS.LIGHT_BLUE,
  },
  h2: {
    fontSize: 14,
    color: COLORS.BLACK,
  },
  primary: { color: COLORS.BLACK },
  secondary: { color: COLORS.GRAY_1 },
  small: { fontSize: 9 },
  xsmall: { fontSize: 8 },
  xxsmall: { fontSize: 7 },
};

export const getBase64FromNode = async (node) => {
  const canvas = await html2canvas(
    node,
    { scrollX: 0, scrollY: -window.scrollY },
  );
  return canvas.toDataURL('image/png');
};

export const getBase64FromURL = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.setAttribute('crossOrigin', 'anonymous');
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      const dataURL = canvas.toDataURL('image/png');
      resolve(dataURL);
    };
    img.onerror = (error) => reject(error);
    img.src = url;
  });
};

export default pdfMake;
